import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';

import Modal from './Modal';

// Constants
import { T } from '../constants/tokens';

/**
 * The generic "are you sure" used across configuration.
 *
 * `color` is kept for callers that pass a status colour, but it now only tints
 * the eyebrow dot — the confirm button stays ink so a routine settings change
 * does not read as loudly as setting an emergency.
 */
function ConfirmationModal({ open, onClose, onConfirm, color = null, title = null, body = null, isLoading = false }) {
  return (
    <Modal
      open={open}
      onClose={isLoading ? undefined : onClose}
      eyebrow='Confirm'
      dotColor={color?.main ?? T.mutedSoft}
      title={title ?? 'Are you sure?'}
      body={body}
      actions={
        <>
          <Button variant='outlined' onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant='contained' color='primary' onClick={onConfirm} autoFocus disabled={isLoading}>
            Confirm
            {isLoading &&
              <CircularProgress size={15} style={{ color: 'inherit', marginLeft: 10 }} />}
          </Button>
        </>
      }
    />
  );
}

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  color: PropTypes.object,
  title: PropTypes.string,
  body: PropTypes.any,
  isLoading: PropTypes.bool
};
